import React from 'react';

import styled from 'styled-components';

import UnstyledButton from 'components/unstyled-button';

import theme from './theme';

const Container = styled.div`
  grid-area: more;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0;
  padding-top: 1.5rem;
  white-space: nowrap;

  ${Styles.desktop`
    padding: 0 0 0.95rem 0.2rem;
  `}
`;

const MoreOptionsButton = styled(UnstyledButton)`
  color: ${Styles.color.primary};
  font-size: 1rem;
  font-family: ${Styles.fontFamily.base};
  text-transform: ${theme.moreOptionsTextTransform};
`;

interface IMoreOptions {
  openFilterModal: () => void;
  buttonText: string;
}
export const MoreOptions: React.FC<IMoreOptions> = ({ openFilterModal, buttonText }) => {
  return (
    <Container>
      <MoreOptionsButton onClick={openFilterModal}>{buttonText}</MoreOptionsButton>
    </Container>
  );
};
